import React from 'react';
import Getstarted from '../components/Getstarted';

const Home = () => {
  return (
    <>
      <Getstarted/>
    </>
  )
}

export default Home;